<form>
  <h1 mat-dialog-title>{{ 'Markets.General.addTest.headerEdit' | translate }}</h1>
  <div class="container">
    <div mat-dialog-content>
      <div class="row">
        <div class="col-12">
          <mat-form-field class="col-12">
            <mat-label>{{'Markets.General.thTestName' | translate}}</mat-label>
            <input type="text" matInput [value]="test.name" disabled/>
          </mat-form-field>
          @for (message of test.messages; track message) {
            <mat-form-field class="col-12">
              <mat-label>
                <img src='{{baseUrl + "/flags/" + message.id + ".png"}}'>
                {{'Markets.General.addTest.lblMessage' | translate}}
              </mat-label>
              <textarea rows="3" matInput [disabled]="service.currentUser.isReadOnly === true" [(ngModel)]="message.value" [ngModelOptions]="{standalone: true}"></textarea>
            </mat-form-field>
          }
          <div class="row">
            <div class="col-lg-6 col-md-12"  style="padding-left: 30px;">
              <mat-checkbox color="primary" [disabled]="service.currentUser.isReadOnly === true" [checked]="test.enabled" (change)="test.enabled = !test.enabled; test.enabled == false ? test.verbose = test.enabled : true;">
                {{'Markets.General.ckbxEnabled' | translate}}
              </mat-checkbox>
            </div>
            <div class="col-lg-6 col-md-12"  style="padding: 0 30px;">
              <mat-checkbox color="primary" [disabled]="service.currentUser.isReadOnly === true || test.enabled === false" [checked]="test.verbose" (change)="test.verbose = !test.verbose">
                {{'Markets.General.thVerbose' | translate}}
              </mat-checkbox>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div mat-dialog-actions>
      @if (service.currentUser.userRole !== operatorRoleName) {
        <button mat-raised-button color="primary" (click)="OnSaveTest()" [disabled]="test.enabled === false">{{'btnOk' | translate}}</button>
        }&nbsp;
        <button mat-raised-button color="secondary" (click)="OnCancel()">{{'btnCancel' | translate}}</button>
      </div>
    </div>
  </form>
